const BASE_ACTION = "AUTH/";
export const STORE_TOKEN = `${BASE_ACTION}SET_TOKEN`;
